import type { ContentfulClientApi } from "contentful";
import { type GetProductInfoByAdGroupOptions, getProductInfoByAdGroup } from "./getProductInfoByAdGroup";

export async function* paginateProductInfoByAdGroup(
    client: ContentfulClientApi<undefined>,
    { adGroups, skip = 0, limit = 50 }: GetProductInfoByAdGroupOptions,
) {
    let total = 0;
    do {
        const response = await getProductInfoByAdGroup(client, { adGroups, skip, limit });

        total = response.total;
        skip += limit;

        yield response;
    } while (skip < total);
}
